<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Cartillas ({{ cartillas.length }})</h3>
      </div>
      <div class="layout__controls">
        <div>
          <button type="button" @click="imprimir" class="btn-info btn--bigger"><i class="fa fa-print"></i><span>Imprimir</span></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div style="max-height: 300px" class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha de venta</th>
                <th>Día de recaudación</th>
                <th>Número de documento</th>
                <th>Recaudador</th>
                <th>Cliente</th>
                <th>Observación</th>
                <th>Valor de pago</th>
                <th>Total</th>
                <th>Saldo</th>
                <th>
                  <div>
                    <button type="button" @click="agregar" class="btn-success"><i class="fa fa-plus"></i></button>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cartilla, index) in cartillas" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ cartilla.fecha }}
                </td>
                <td>
                  {{ cartilla.descripcion_dia_cobro }}
                </td>
                <td>
                  {{ cartilla.numero_documento }}
                </td>
                <td>
                  {{ cartilla.recaudador.nombre }}
                </td>
                <td>
                  {{ cartilla.nombre_cliente }}
                </td>
                <td>
                  {{ cartilla.observacion }}
                </td>
                <td>
                  {{ moneyFormat(cartilla.valor_pagos) }}
                </td>
                <td>
                  {{ moneyFormat(cartilla.valor_total) }}
                </td>
                <td>
                  {{ moneyFormat(cartilla.saldo_total) }}
                </td>
                <td>

                </td>
              </tr>
              <tr v-for="(cartilla, index) in cartillasAdicionales" :key="index">
                <td>
                  {{ cartilla.fecha }}
                </td>
                <td>
                  {{ cartilla.descripcion_dia_cobro }}
                </td>
                <td>
                  {{ cartilla.numero_documento }}
                </td>
                <td>
                  {{ cartilla.recaudador.nombre }}
                </td>
                <td>
                  {{ cartilla.nombre_cliente }}
                </td>
                <td>
                  {{ cartilla.observacion }}
                </td>
                <td>
                  {{ moneyFormat(cartilla.valor_pagos) }}
                </td>
                <td>
                  {{ moneyFormat(cartilla.valor_total) }}
                </td>
                <td>
                  {{ moneyFormat(cartilla.saldo_total) }}
                </td>
                <td>
                  <button class="btn-danger btn--text" type="button" @click="quitarCartilla(cartilla)"><i
                      class="fa fa-times"></i></button>
                </td>
              </tr>
              <tr v-if="cartillas.length === 0 && cartillasAdicionales.length === 0">
                <td colspan="11">No se ha encontrado recaudaciones</td>
              </tr>
              <tr v-else>
                <td colspan="7">
                  <b> Totales </b>
                </td>
                <td> <b>  {{ moneyFormat(calcularTotalValorPago()) }} </b> </td>
                <td> </td>
                <td> <b> {{ moneyFormat(calcularTotalSaldo()) }} </b> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
    <modal name="cartillasAdicionales" scrollable height="auto" width="80%" adaptive resizable reset>
      <cartillas-adicionales @asignadas="cartillasAsignadas" @cerrar="$modal.hide('cartillasAdicionales')"
        :recaudacionId="recaudacionId"></cartillas-adicionales>
    </modal>
  </div>
</template>

<script>
import CartillasAdicionales from './CartillasAdicionales.vue';
export default {
  components: {
    CartillasAdicionales
  },
  props: {
    recaudacionId: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function () {
    return {
      cartillas: [],
      moneyFormat: moneyFormat,
      cartillasAdicionales: []
    };
  },
  methods: {
    imprimir: function () {
      window.open(url + '/logistica/recaudaciones/' + this.recaudacionId + '/listado?pdf=S', '_blank');
    },  
    cartillasAsignadas: function () {
      this.cargarCartillas();
    },
    quitarCartilla: function (cartilla) {
      swal({
        title: "¿Deseas quitar los items asignados?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/quitar-cartillas", {
              recaudacion_id: this.recaudacionId,
              cartilla_id: cartilla.id
            })
            .then(() => {
              this.cargarCartillas();
              swal(
                "Se ha quitado la cartilla seleccionada.",
                "Realizado",
                "success"
              );
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    agregar: function () {
      this.$modal.show('cartillasAdicionales');
    },
    cargarCartillas: function () {
      axios.get(url + '/logistica/recaudaciones/' + this.recaudacionId + '/listado').then(({ data }) => {
        this.cartillas = data.pedidos;
        this.cartillasAdicionales = data.cartillas;
      }).catch(() => {
        swal('Hubo un error al cargar las cartillas, intente nuevamente.', 'Error', 'error');
      });
    },
    cerrar: function () {
      this.$emit("cerrar");
    },
    calcularTotalValorPago: function () {
      const totalCartillas = this.cartillas.map(cartilla => parseFloat(cartilla.valor_pagos))
        .reduce((previous, current) => previous + current, 0);
      const totalCartillasAdicionales = this.cartillasAdicionales.map(cartilla => parseFloat(cartilla.valor_pagos))
        .reduce((previous, current) => previous + current, 0);
      return totalCartillas + totalCartillasAdicionales;
    },
    calcularTotalSaldo: function () {
      const totalCartillas = this.cartillas.map(cartilla => parseFloat(cartilla.saldo_total))
        .reduce((previous, current) => previous + current, 0);
      const totalCartillasAdicionales = this.cartillasAdicionales.map(cartilla => parseFloat(cartilla.saldo))
        .reduce((previous, current) => previous + current, 0);
      return totalCartillas + totalCartillasAdicionales;
    }
  },
  mounted: function () {
    this.cargarCartillas();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/CartillasRecaudacion.vue